import { test, expect } from '@playwright/test';

const primaryButtonIds = [
	// Primary
	'button-primary-large',
	'button-primary-medium',
	'button-primary-small',
	'button-primary-disabled',
	'button-primary-large-icon-before',
	'button-primary-medium-icon-before',
	'button-primary-small-icon-before',
	'button-primary-disabled-icon-before',
	'button-primary-large-icon-after',
	'button-primary-medium-icon-after',
	'button-primary-small-icon-after',
	'button-primary-disabled-icon-after',
	'button-primary-large-icon-only',
	'button-primary-medium-icon-only',
	'button-primary-small-icon-only',
	'button-primary-disabled-icon-only',
];
const secondaryButtonIds = [
	// Secondary
	'button-secondary-large',
	'button-secondary-medium',
	'button-secondary-small',
	'button-secondary-disabled',
	'button-secondary-large-icon-before',
	'button-secondary-medium-icon-before',
	'button-secondary-small-icon-before',
	'button-secondary-disabled-icon-before',
	'button-secondary-large-icon-after',
	'button-secondary-medium-icon-after',
	'button-secondary-small-icon-after',
	'button-secondary-disabled-icon-after',
	'button-secondary-large-icon-only',
	'button-secondary-medium-icon-only',
	'button-secondary-small-icon-only',
	'button-secondary-disabled-icon-only',
];
const tertiaryButtonIds = [
	// Tertiary
	'button-tertiary-large',
	'button-tertiary-medium',
	'button-tertiary-small',
	'button-tertiary-disabled',
	'button-tertiary-large-icon-before',
	'button-tertiary-medium-icon-before',
	'button-tertiary-small-icon-before',
	'button-tertiary-disabled-icon-before',
	'button-tertiary-large-icon-after',
	'button-tertiary-medium-icon-after',
	'button-tertiary-small-icon-after',
	'button-tertiary-disabled-icon-after',
	'button-tertiary-large-icon-only',
	'button-tertiary-medium-icon-only',
	'button-tertiary-small-icon-only',
	'button-tertiary-disabled-icon-only',
];
const criticalButtonIds = [
	// Critical
	'button-critical-large',
	'button-critical-medium',
	'button-critical-small',
	'button-critical-disabled',
	'button-critical-large-icon-before',
	'button-critical-medium-icon-before',
	'button-critical-small-icon-before',
	'button-critical-disabled-icon-before',
	'button-critical-large-icon-after',
	'button-critical-medium-icon-after',
	'button-critical-small-icon-after',
	'button-critical-disabled-icon-after',
	'button-critical-large-icon-only',
	'button-critical-medium-icon-only',
	'button-critical-small-icon-only',
	'button-critical-disabled-icon-only',
];

const dangerButtonIds = [
	// Danger
	'button-danger-primary-large',
	'button-danger-primary-medium',
	'button-danger-primary-small',
	'button-danger-primary-disabled',
	'button-danger-primary-large-icon-before',
	'button-danger-primary-medium-icon-before',
	'button-danger-primary-small-icon-before',
	'button-danger-primary-disabled-icon-before',
	'button-danger-primary-large-icon-after',
	'button-danger-primary-medium-icon-after',
	'button-danger-primary-small-icon-after',
	'button-danger-primary-disabled-icon-after',
	'button-danger-primary-large-icon-only',
	'button-danger-primary-medium-icon-only',
	'button-danger-primary-small-icon-only',
	'button-danger-primary-disabled-icon-only',
	'button-danger-secondary-large',
	'button-danger-secondary-medium',
	'button-danger-secondary-small',
	'button-danger-secondary-disabled',
	'button-danger-secondary-large-icon-before',
	'button-danger-secondary-medium-icon-before',
	'button-danger-secondary-small-icon-before',
	'button-danger-secondary-disabled-icon-before',
	'button-danger-secondary-large-icon-after',
	'button-danger-secondary-medium-icon-after',
	'button-danger-secondary-small-icon-after',
	'button-danger-secondary-disabled-icon-after',
	'button-danger-secondary-large-icon-only',
	'button-danger-secondary-medium-icon-only',
	'button-danger-secondary-small-icon-only',
	'button-danger-secondary-disabled-icon-only',
	'button-danger-tertiary-large',
	'button-danger-tertiary-medium',
	'button-danger-tertiary-small',
	'button-danger-tertiary-disabled',
	'button-danger-tertiary-large-icon-before',
	'button-danger-tertiary-medium-icon-before',
	'button-danger-tertiary-small-icon-before',
	'button-danger-tertiary-disabled-icon-before',
	'button-danger-tertiary-large-icon-after',
	'button-danger-tertiary-medium-icon-after',
	'button-danger-tertiary-small-icon-after',
	'button-danger-tertiary-disabled-icon-after',
	'button-danger-tertiary-large-icon-only',
	'button-danger-tertiary-medium-icon-only',
	'button-danger-tertiary-small-icon-only',
	'button-danger-tertiary-disabled-icon-only',
];

test.describe('button-component', () => {
	test.beforeEach(async ({ page }) => {
		await page.goto('iframe.html?viewMode=docs&id=test-button--docs');
	});

	test('visibility', async ({ page }) => {
		const buttonIds = [...primaryButtonIds, ...secondaryButtonIds, ...tertiaryButtonIds, ...criticalButtonIds, ...dangerButtonIds];

		for (const id of buttonIds) {
			await expect(page.locator(`#${id}`)).toBeVisible();
		}
	});

	test('design-implementation', async ({ page }) => {
		const buttonIds = [...primaryButtonIds, ...secondaryButtonIds, ...tertiaryButtonIds, ...criticalButtonIds, ...dangerButtonIds];
		await page.reload();

		for (const id of buttonIds) {
			// Default state
			await expect(page.locator(`#${id}`)).toHaveScreenshot(`${id}.png`);
			// Hover state
			page.locator(`#${id}`).hover();
			await expect(page.locator(`#${id}`)).toHaveScreenshot(`${id}-hover.png`);
			// Focus state
			await page.evaluate((id) => {
				const element = document.getElementById(id);
				if (element) {
					const parentDiv = document.createElement('div');
					parentDiv.style.padding = '10px';
					parentDiv.style.backgroundColor = 'white';
					element.parentNode?.insertBefore(parentDiv, element);
					parentDiv.appendChild(element);
				}
			}, id);
			page.locator(`#${id}`).focus();
			const parentDiv = await page.locator(`#${id}`).locator('xpath=..');
			await expect(parentDiv).toHaveScreenshot(`${id}-focus.png`);
		}
	});

	test('form-submission', async ({ page }) => {
		let requestUrl: URL | undefined;
		page.on('request', (request) => {
			if (request.url().includes('iframe.html?first-name=John')) {
				requestUrl = new URL(request.url());
			}
		});

		await page.locator('#first-name').pressSequentially('John');
		await page.locator('#submit-button').click();
		await expect(requestUrl?.searchParams.get('first-name')).toBe('John');
	});

	test('form-reset', async ({ page }) => {
		await page.locator('#first-name').pressSequentially('John');
		await page.locator('#reset-button').click();
		const value = await page.locator('#first-name').getAttribute('value');
		expect(value).toBeNull();
	});
});
